import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import PharmacyShop from '../views/PharmacyShop';
import PharmacyOrders from '../views/PharmacyOrders';
import { STR_MENU_ARTICLES, STR_MENU_CHAT_ROOMS, STR_MENU_DOCTOR_ROOMS, STR_MENU_STORIES, STR_MENU_UTILITIES, STR_TAB_MY_ORDERS, STR_TAB_SHOP } from "../Strings";
import LoginView from '../views/LoginView';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..

		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])

	
	if (ready) {
		return (
			<div
				className="HomeLanding"
			>
				<TabbedView
					tabs={
						[
							{ id: 0, label: STR_TAB_SHOP[appContext.language], content: <PharmacyShop /> },
							{ id: 1, label: STR_TAB_MY_ORDERS[appContext.language], content: <PharmacyOrders /> },
						]
					}
				/>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}
	
	


}